<template>
  <section id="report">
    <div class="mb-4 card">
      <div class="d-sm-flex justify-content-between p-2 pb-3">
        <h4 class="mb-sm-0 pt-2">
          <a href="/dashboard">Home Page</a><span>/</span><span>Dashboard</span><span>/</span><b>Report</b>
        </h4>
      </div>
    </div>
    <section class="mt-lg-1" v-if="currentPage == 'report'">
      <mdb-row>

        <mdb-col md="12" class="mb-r">
          <mdb-card
            cascade
            class="cascading-admin-card classic-admin-card bg-dark white-text"
          >
            
            <mdb-card-body>
              <label>Deactivated Students : {{disabledStudents.length}}</label>
              
              <button class="btn btn-outline-white btn-block btn-sm" @click.prevent="viewDisabledStudents()" v-if="disabledStudents.length > 0">
                View
              </button>
            </mdb-card-body>
          </mdb-card>
        </mdb-col>

        <mdb-col md="6" class="mb-r">
          <mdb-card
            cascade
            class="cascading-admin-card classic-admin-card bg-dark white-text"
          >
            
            <mdb-card-body>
              <label>Search Student</label>
              <input type="text" v-model="searchStudent" class="form-control mb-4">
              <button class="btn btn-outline-white btn-block btn-sm" @click.prevent="searchStudentF()">
                Search Students
              </button>
            </mdb-card-body>
          </mdb-card>
        </mdb-col>

        <mdb-col md="6" class="mb-r">
          <mdb-card
            cascade
            class="cascading-admin-card classic-admin-card bg-dark white-text"
          >
            
            <mdb-card-body>
              <label>Search Teacher</label>
              <input type="text" v-model="searchTeacher" class="form-control mb-4">
              <button class="btn btn-outline-white btn-block btn-sm" @click.prevent="searchTeacherF()">
                Search Teacher
              </button>
            </mdb-card-body>
          </mdb-card>
        </mdb-col>

        <mdb-col md="6" class="mb-r">
          <mdb-card
            cascade
            class="cascading-admin-card classic-admin-card bg-dark white-text"
          >
            
            <mdb-card-body>
              <label>Search By Class</label>
                <select class="form-control mb-4" v-model="searchClass">
                  <option selected disabled>-- Select A Class --</option>
                  <option
                    v-for="item in classes"
                    :key="item"
                    v-bind:value="item"
                  >
                  {{item}}
                  </option>
                </select>
              <button class="btn btn-outline-white btn-block btn-sm" @click.prevent="searchClassF()">
                Search By Class
              </button>
            </mdb-card-body>
          </mdb-card>
        </mdb-col>

        <mdb-col md="6" class="mb-r">
          <mdb-card
            cascade
            class="cascading-admin-card classic-admin-card bg-dark white-text"
          >
            
            <mdb-card-body>
              <label>Search By Type</label>
                <select class="form-control mb-4" v-model="searchType">
                  <option selected disabled>-- Select A Type --</option>
                  <option
                    v-for="stype in totalTypes"
                    :key="stype"
                    v-bind:value="stype"
                  >
                  {{ stype }}
                  </option>
                </select>
              <button class="btn btn-outline-white btn-block btn-sm" @click.prevent="searchTypeF()">
                Search By Type
              </button>
            </mdb-card-body>
          </mdb-card>
        </mdb-col>

        <mdb-col md="6" class="mb-r">
          <mdb-card
            cascade
            class="cascading-admin-card classic-admin-card bg-dark white-text"
          >
            
            <mdb-card-body>
              <label>Search By Group</label>
                <select class="form-control mb-4" v-model="searchGroup">
                  <option selected disabled>-- Select A Group --</option>
                  <option
                    v-for="group in totalGroups"
                    :key="group.group"
                    v-bind:value="group.group"
                  >
                  Group  {{ group.group }}
                  </option>
                </select>
                <button class="btn btn-outline-white btn-block btn-sm" @click.prevent="searchGroupF()">
                  Search By Group
                </button>
            </mdb-card-body>
          </mdb-card>
        </mdb-col>

        <mdb-col md="6" class="mb-r">
          <mdb-card
            cascade
            class="cascading-admin-card classic-admin-card bg-dark white-text"
          >
            <mdb-card-body>
              <label>Report By Group</label>
                <select class="form-control mb-4" v-model="selectGroup">
                  <option selected disabled>-- Select A Group --</option>
                  <option
                    v-for="group in totalGroups"
                    :key="group.group"
                    v-bind:value="group.group"
                  >
                  Group  {{ group.group }}
                  </option>
                </select>
                <button class="btn btn-outline-white btn-block btn-sm" @click.prevent="goStatusReport()">
                  Search By Group
                </button>
            </mdb-card-body>
          </mdb-card>
        </mdb-col>

        <mdb-col md="6" class="mb-r">
          <mdb-card
            cascade
            class="cascading-admin-card classic-admin-card bg-dark white-text"
          >
            
            <mdb-card-body>
              <label>Search By Program</label>
                <select class="form-control mb-4" v-model="searchProgram">
                  <option selected disabled>-- Select A Program --</option>
                  <option
                    v-for="value in totalPrograms"
                    :key="value"
                    v-bind:value="value"
                  >
                  {{ value }}
                  </option>
                </select>
                <button class="btn btn-outline-white btn-block btn-sm" @click.prevent="searchProgramF()">
                Search By Program
              </button>
            </mdb-card-body>
          </mdb-card>
        </mdb-col>

        <mdb-col md="6" class="mb-r">
          <mdb-card
            cascade
            class="cascading-admin-card classic-admin-card bg-dark white-text"
          >
            
            <mdb-card-body>
              <label>Search By Level</label>
                  <select class="form-control mb-4" v-model="searchLevel">
                    <option selected disabled>-- Select A Level --</option>
                    <option
                      v-for="level in totalLevels"
                      :key="level._id"
                      v-bind:value="level.target + ' ' + level.step"
                    >
                    {{ level.target }}  {{ level.step }}
                    </option>
                  </select>
                <button class="btn btn-outline-white btn-block btn-sm" @click.prevent="searchLevelF()">
                Search By Level
              </button>
            </mdb-card-body>
          </mdb-card>
        </mdb-col>

      </mdb-row>
    </section>

    <section class="mt-lg-1" v-if="currentPage == 'search-student'">
      <mdb-row>
        <mdb-col md="12" class="mb-r">
          <mdb-card
            cascade
            class="cascading-admin-card classic-admin-card bg-dark white-text"
          >
            <mdb-card-body>
              <label @click.prevent="returnReport()"><mdb-icon icon="arrow-left" fas class="bg-dark mr-2" /> Search Student</label>
              <mdb-row>
                <mdb-col md="6">
                  <input type="text" v-model="searchStudent" class="form-control">
                </mdb-col>
                <mdb-col md="2">
                  <button class="btn btn-outline-white btn-block btn-sm mt-1" @click.prevent="searchStudentF()">
                    Search
                  </button>
                </mdb-col>
                <mdb-col md="2">
                  <button class="btn btn-outline-white btn-block btn-sm mt-1"  @click.prevent="getAllStudents()">
                    All
                  </button>
                </mdb-col>
                <mdb-col md="2">
                  <button class="btn btn-outline-white btn-block btn-sm mt-1" @click.prevent="downloadCSV()">
                    CSV
                  </button>
                </mdb-col>
              </mdb-row>
              
            </mdb-card-body>
          </mdb-card>
        </mdb-col>
      </mdb-row>
    </section>

    <section class="mt-lg-1" v-if="currentPage == 'search-teacher'">
      <mdb-row>
        <mdb-col md="12" class="mb-r">
          <mdb-card
            cascade
            class="cascading-admin-card classic-admin-card bg-dark white-text"
          >
            <mdb-card-body>
              <label @click.prevent="returnReport()"><mdb-icon icon="arrow-left" fas class="bg-dark mr-2" /> Search Teacher</label>
              <mdb-row>
                <mdb-col md="6">
                  <input type="text" v-model="searchTeacher" class="form-control">
                </mdb-col>
                <mdb-col md="2">
                  <button class="btn btn-outline-white btn-block btn-sm mt-1" @click.prevent="searchTeacherF()">
                    Search
                  </button>
                </mdb-col>
                <mdb-col md="2">
                  <button class="btn btn-outline-white btn-block btn-sm mt-1"  @click.prevent="getAllTeachers()">
                    All
                  </button>
                </mdb-col>
                <mdb-col md="2">
                  <button class="btn btn-outline-white btn-block btn-sm mt-1" @click.prevent="downloadCSV()">
                    CSV
                  </button>
                </mdb-col>
              </mdb-row>
              
            </mdb-card-body>
          </mdb-card>
        </mdb-col>
      </mdb-row>
    </section>

    <section class="mt-lg-1" v-if="currentPage == 'search-by-class'">
      <mdb-row>
        <mdb-col md="12" class="mb-r">
          <mdb-card
            cascade
            class="cascading-admin-card classic-admin-card bg-dark white-text"
          >
            
            <mdb-card-body>
              <label @click.prevent="returnReport()"><mdb-icon icon="arrow-left" fas class="bg-dark mr-2" /> Search By Class</label>
              <mdb-row>
                <mdb-col md="6">
                  <select class="form-control" v-model="searchClass">
                    <option selected disabled>-- Select A Class --</option>
                    <option
                      v-for="item in classes"
                      :key="item"
                      v-bind:value="item"
                    >
                    {{item}}
                    </option>
                  </select>
                </mdb-col>
                <mdb-col md="2">
                  <button class="btn btn-outline-white btn-block btn-sm mt-1" @click.prevent="searchClassF()">
                    Search
                  </button>
                </mdb-col>
                <mdb-col md="2">
                  <button class="btn btn-outline-white btn-block btn-sm mt-1"  @click.prevent="getAllStudents()">
                    All
                  </button>
                </mdb-col>
                <mdb-col md="2">
                  <button class="btn btn-outline-white btn-block btn-sm mt-1" @click.prevent="downloadCSV()">
                    CSV
                  </button>
                </mdb-col>
              </mdb-row>
              
            </mdb-card-body>
          </mdb-card>
        </mdb-col>
      </mdb-row>
    </section>

    <section class="mt-lg-1" v-if="currentPage == 'search-by-group'">
      <mdb-row>
        <mdb-col md="12" class="mb-r">
          <mdb-card
            cascade
            class="cascading-admin-card classic-admin-card bg-dark white-text"
          >
            
            <mdb-card-body>
              <label @click.prevent="returnReport()"><mdb-icon icon="arrow-left" fas class="bg-dark mr-2" /> Search By Group</label>
              <mdb-row>
                <mdb-col md="6">
                  <select class="form-control" v-model="searchGroup">
                    <option selected disabled>-- Select A Group --</option>
                    <option
                      v-for="group in totalGroups"
                      :key="group.group"
                      v-bind:value="group.group"
                    >
                    Group  {{ group.group }}
                    </option>
                  </select>
                </mdb-col>
                <mdb-col md="2">
                  <button class="btn btn-outline-white btn-block btn-sm mt-1" @click.prevent="searchGroupF()">
                    Search
                  </button>
                </mdb-col>
                <mdb-col md="2">
                  <button class="btn btn-outline-white btn-block btn-sm mt-1"  @click.prevent="getAllStudents()">
                    All
                  </button>
                </mdb-col>
                <mdb-col md="2">
                  <button class="btn btn-outline-white btn-block btn-sm mt-1" @click.prevent="downloadCSV()">
                    CSV
                  </button>
                </mdb-col>
              </mdb-row>
              
            </mdb-card-body>
          </mdb-card>
        </mdb-col>
      </mdb-row>
    </section>

    <section class="mt-lg-1" v-if="currentPage == 'search-by-type'">
      <mdb-row>
        <mdb-col md="12" class="mb-r">
          <mdb-card
            cascade
            class="cascading-admin-card classic-admin-card bg-dark white-text"
          >
            
            <mdb-card-body>
              <label @click.prevent="returnReport()"><mdb-icon icon="arrow-left" fas class="bg-dark mr-2" /> Search By Type</label>
              <mdb-row>
                <mdb-col md="6">
                <select class="form-control" v-model="searchType">
                  <option selected disabled>-- Select A Type --</option>
                  <option
                    v-for="stype in totalTypes"
                    :key="stype"
                    v-bind:value="stype"
                  >
                  {{ stype }}
                  </option>
                </select>
                </mdb-col>
                <mdb-col md="2">
                  <button class="btn btn-outline-white btn-block btn-sm mt-1" @click.prevent="searchTypeF()">
                    Search
                  </button>
                </mdb-col>
                <mdb-col md="2">
                  <button class="btn btn-outline-white btn-block btn-sm mt-1"  @click.prevent="getAllStudents()">
                    All
                  </button>
                </mdb-col>
                <mdb-col md="2">
                  <button class="btn btn-outline-white btn-block btn-sm mt-1" @click.prevent="downloadCSV()">
                    CSV
                  </button>
                </mdb-col>
              </mdb-row>
              
            </mdb-card-body>
          </mdb-card>
        </mdb-col>
      </mdb-row>
    </section>

    <section class="mt-lg-1" v-if="currentPage == 'search-by-program'">
      <mdb-row>
        <mdb-col md="12" class="mb-r">
          <mdb-card
            cascade
            class="cascading-admin-card classic-admin-card bg-dark white-text"
          >
            
            <mdb-card-body>
              <label @click.prevent="returnReport()"><mdb-icon icon="arrow-left" fas class="bg-dark mr-2" /> Search By Program</label>
              <mdb-row>
                <mdb-col md="6">
                <select class="form-control" v-model="searchProgram">
                  <option selected disabled>-- Select A Program --</option>
                  <option
                    v-for="value in totalPrograms"
                    :key="value"
                    v-bind:value="value"
                  >
                  {{ value }}
                  </option>
                </select>
                </mdb-col>
                <mdb-col md="2">
                  <button class="btn btn-outline-white btn-block btn-sm mt-1" @click.prevent="searchProgramF()">
                    Search
                  </button>
                </mdb-col>
                <mdb-col md="2">
                  <button class="btn btn-outline-white btn-block btn-sm mt-1"  @click.prevent="getAllStudents()">
                    All
                  </button>
                </mdb-col>
                <mdb-col md="2">
                  <button class="btn btn-outline-white btn-block btn-sm mt-1" @click.prevent="downloadCSV()">
                    CSV
                  </button>
                </mdb-col>
              </mdb-row>
              
            </mdb-card-body>
          </mdb-card>
        </mdb-col>
      </mdb-row>
    </section>

    <section class="mt-lg-1" v-if="currentPage == 'search-by-level'">
      <mdb-row>
        <mdb-col md="12" class="mb-r">
          <mdb-card
            cascade
            class="cascading-admin-card classic-admin-card bg-dark white-text"
          >
            
            <mdb-card-body>
              <label @click.prevent="returnReport()"><mdb-icon icon="arrow-left" fas class="bg-dark mr-2" /> Search By Level</label>
              <mdb-row>
                <mdb-col md="6">
                  <select class="form-control" v-model="searchLevel">
                    <option selected disabled>-- Select A Level --</option>
                    <option
                      v-for="level in totalLevels"
                      :key="level._id"
                      v-bind:value="level.target + ' ' + level.step"
                    >
                    {{ level.target }}  {{ level.step }}
                    </option>
                  </select>
                </mdb-col>
                <mdb-col md="2">
                  <button class="btn btn-outline-white btn-block btn-sm mt-1" @click.prevent="searchLevelF()">
                    Search
                  </button>
                </mdb-col>
                <mdb-col md="2">
                  <button class="btn btn-outline-white btn-block btn-sm mt-1"  @click.prevent="getAllStudents()">
                    All
                  </button>
                </mdb-col>
                <mdb-col md="2">
                  <button class="btn btn-outline-white btn-block btn-sm mt-1" @click.prevent="downloadCSV()">
                    CSV
                  </button>
                </mdb-col>
              </mdb-row>
              
            </mdb-card-body>
          </mdb-card>
        </mdb-col>
      </mdb-row>
    </section>

    <section class="mt-lg-1" v-if="currentPage == 'disabled-student'">
      <mdb-row>
        <mdb-col md="12" class="mb-r">
          <mdb-card
            cascade
            class="cascading-admin-card classic-admin-card bg-dark white-text"
          >
            
            <mdb-card-body>
              <label @click.prevent="returnReport()"><mdb-icon icon="arrow-left" fas class="bg-dark mr-2" /> Deactivated Students: {{disabledStudents.length}}</label>
              <mdb-row>
                <mdb-col md="6">
                  <input type="text" v-model="searchStudent" class="form-control">
                </mdb-col>
                <mdb-col md="2">
                  <button class="btn btn-outline-white btn-block btn-sm mt-1" @click.prevent="searchDisabledStudentF()">
                    Search
                  </button>
                </mdb-col>
                <mdb-col md="2">
                  <button class="btn btn-outline-white btn-block btn-sm mt-1"  @click.prevent="viewDisabledStudents()">
                    All
                  </button>
                </mdb-col>
                <mdb-col md="2">
                  <button class="btn btn-outline-white btn-block btn-sm mt-1" @click.prevent="downloadCSV()">
                    CSV
                  </button>
                </mdb-col>
              </mdb-row>
            </mdb-card-body>
          </mdb-card>
        </mdb-col>
      </mdb-row>
    </section>

    <section class="mt-lg-1 students-view" v-if="currentPage != 'search-teacher' && currentPage != 'report'">
      <div class="table-responsive">

        <table class="table table-bordered">
          <thead class="thead-dark">
            <tr>
              <th scope="col">Action</th>
              <th scope="col">Name</th>
              <th scope="col">First Name</th>
              <th scope="col">Last Name</th>
              <th scope="col">User Name</th>
              <th scope="col">Age Bracket</th>
              <th scope="col">Level</th>
              <th scope="col">Lesson Number</th>
              <th scope="col">Lesson Day</th>
              <th scope="col">Lesson Type</th>
              <th scope="col">School Grade</th>
              <th scope="col">Type</th>
              <th scope="col">Class</th>
              <th scope="col">Group #</th>
              <th scope="col">City</th>
              <th scope="col">Guardian Name</th>
              <th scope="col">Guardian Email</th>
              <th scope="col">Guardian Phone</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="student in students" :key="student._id" >
              <td>
                <div class="d-flex">
                  <input type="checkbox" class="mr-3" v-model="checkedIds" :value="student._id"/>
                  <span @click.prevent="getStudentProgress(student)"><i class="fas fa-info-circle mr-3 text-primary"></i></span>
                  <router-link :to="{ name: 'EditStudent', params : {student_id : student._id} }">
                    <i class="fas fa-edit mr-3 text-primary"></i> 
                  </router-link>
                  <span @click.prevent="getStudentBourdon(student)"><i class="fas fa-brain mr-3 text-success"></i></span>
                  <span @click.prevent="activationStudent(student)" v-if="!student.disabled"><i class="fas fa-toggle-on text-success"></i></span>
                  <span @click.prevent="activationStudent(student)" v-if="student.disabled"><i class="fas fa-toggle-off text-danger"></i></span>
                </div>
              </td>
              <th>{{ student.name }}</th>
              <th>{{ student.first_name }}</th>
              <td>{{ student.last_name }}</td>
              <td>{{ student.username }}</td>
              <td>{{ student.age_bracket }}</td>
              <td>{{ student.level }}</td>
              <td>{{ student.lesson }}</td>
              <td>{{ student.lesson_day }}</td>
              <td>{{ student.lesson_type == 's' ? 'Static' : student.lesson_type == 'a' ? 'Audible' : 'Flash' }}</td>
              <td>{{ student.school_grade }}</td>
              <td>{{ student.type }}</td>
              <td>{{ student.class }}</td>
              <td>{{ student.group }}</td>
              <td>{{ student.city }}</td>
              <td>{{ student.guardian_name }}</td>
              <td>{{ student.guardian_email }}</td>
              <td>{{ student.guardian_phone }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <mdb-row v-if="checkedIds.length > 0">
        <mdb-col md="3">
          <button class="btn btn-sm btn-danger" @click.prevent="bulkDeactivate">Deactive bulk students</button>
        </mdb-col>
        
        <mdb-col md="3">
          <select v-model="changingLevel">
            <option selected disabled>-- Select A Level --</option>
            <option
              v-for="level in totalLevels"
              :key="level._id"
              v-bind:value="level.target + ' ' + level.step"
            >
            {{ level.target }}  {{ level.step }}
            </option>
          </select>
          <button class="btn btn-sm btn-primary" @click.prevent="bulkChangeLevel">Change Level</button>
        </mdb-col>

        <mdb-col md="3">
          <select v-model="changingGroup">
            <option selected disabled>-- Select A Group --</option>
            <option
              v-for="group in totalGroups"
              :key="group.group"
              v-bind:value="group.group"
            >
            Group  {{ group.group }}
            </option>
          </select>
          <button class="btn btn-sm btn-default" @click.prevent="bulkChangeGroup">Change Group</button>
        </mdb-col>
      </mdb-row>
    </section>

    <section class="mt-lg-1 teachers-view" v-if="currentPage == 'search-teacher'">
        <div class="table-responsive">
            <table class="table table-bordered">
                <thead class="thead-dark">
                    <tr>
                        <th scope="col">First Name</th>
                        <th scope="col">Last Name</th>
                        <th scope="col">Email</th>
                        <th scope="col">City</th>
                        <th scope="col">Take Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(teacher) in teachers" :key="teacher._id">
                        <th>{{teacher.first_name}}</th>
                        <td>{{teacher.last_name}}</td>
                        <td>{{teacher.email}}</td>
                        <td>{{teacher.city}}</td>
                        <td>
                            <router-link :to="{ name: 'EditTeacher', params : {user_id : teacher._id} }">
                                <button class="btn btn-info btn-sm">Edit</button>
                            </router-link>

                            <button class="btn btn-success btn-sm " v-if="teacher.disabled" @click="activate(teacher._id)">Activate</button>

                            <button class="btn btn-dark btn-sm" v-if="teacher.disabled == false" @click="deactivate(teacher._id)">Deactivate</button>

                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </section>
    <mdb-modal size="lg" class="videoConferencing" :show="isSelectedUser" removeBackdrop centered scrollable>
      <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal" @click="isSelectedUser = false">Close</button>
      <div class="card z-depth-1 p-3 bg-dark mx-1">
        <mdb-row>
          <mdb-col md="12" class="pt-4">
            <h1 class="text text-white d-flex justify-content-between">
              {{selectedStudent.first_name}}
              {{selectedStudent.last_name}}
              <span class="small">
                Nivel:
                <select v-model="currentLevel" @change="loadLesssons()">
                  <option  
                  v-for="level in levels" 
                  :key="level._id" 
                  v-bind:value="level"
                  >{{ level.step }}</option>
                </select>
              </span>
            </h1>
            <p class="text-white">
              <router-link :to="{ name: 'TeacherEditProgress', params : {student_id : selectedStudent._id} }">
                <i class="fas fa-edit ml-2 text-warning"></i> 
              </router-link>
              This student is at <b>{{selectedStudent.age_bracket}}</b>
              <b v-if="progress.level_data">, {{progress.level_data.title}}, 
              Lesson {{progress.group}}, Day {{progress.day}},</b>
              <b v-if="progress.type=='s'"> Static</b>
              <b v-if="progress.type=='a'"> Audible</b>
              <b v-if="progress.type=='f'"> Flash</b>
              
            </p>
          </mdb-col>
        </mdb-row>
      </div>
      <div class="m-1 student-details">
        <table class="table table-bordered">
          <thead>
            <tr>
              <td>Lección</td>
              <td>Promedio</td>
              <td>Ver información</td>
            </tr>
          </thead>
          <tbody  v-for="data of studentDetails" :key="data.index">
            <tr>
              <td>
                <div class="lesson">
                  <img src="@/assets/lock1.png" class="img-fluid" v-if="data.status=='pending'"/>
                  <img src="@/assets/run.png" class="img-fluid" v-if="data.status=='current'"/>
                  <img src="@/assets/check_circle.png" class="img-fluid" v-if="data.status=='past'"/>
                  <span v-if="data.status!='pending'">Lección {{data.index}} ({{data.passed}} de {{data.total}} completado)</span>
                  <span v-if="data.status=='pending'">Lección {{data.index}}</span>
                </div>
              </td>
              <td v-if="data.status=='pending'">Pendiente</td>
              <td v-if="data.status!='pending'">{{data.score}}</td>
              <td>
                <div class="view-details" @click.prevent="data.show=!data.show">
                  Ver Detalles 
                  <i class="fas fa-angle-down" v-if="!data.show"/>
                  <i class="fas fa-angle-up" v-if="data.show"/>
                </div>
              </td>
            </tr>
            <tr class="lesson-more" v-if="data.show">
              <td colspan="3">
                <div class="d-flex">
                  <div class="col-4">
                    <div class="lesson-more-title">
                      Estáticas
                    </div>
                    <div class="lesson-more-label">Calificación promedio de nivel:</div>
                    <div class="lesson-more-score">
                      {{data.s_score}}
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="lesson-more-title">
                      Dictadas
                    </div>
                    <div class="lesson-more-label">Calificación promedio de nivel:</div>
                    <div class="lesson-more-score">
                      {{data.a_score}}
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="lesson-more-title">
                      Flash
                    </div>
                    <div class="lesson-more-label">Calificación promedio de nivel:</div>
                    <div class="lesson-more-score">
                      {{data.f_score}}
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>  
      </div>
    </mdb-modal>

    <mdb-modal size="lg" class="videoConferencing" :show="showBourdonModal" removeBackdrop centered scrollable>
      <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal" @click="showBourdonModal = false">Close</button>
      <mdb-modal-body>
          <div class="card z-depth-5 p-3 bg-dark">
            <mdb-row>
              <mdb-col md="2" v-if="selectedStudent.avatar">
                <img :src="selectedStudent.avatar" alt="avatar" width="120" v-if="selectedStudent.avatar"> 
              </mdb-col>
              <mdb-col md="10" class="pt-4">
                <h1 class="text text-white">
                  {{selectedStudent.first_name}}
                  {{selectedStudent.last_name}}
                </h1>
                <p class="text-white">This student is at <b>{{selectedStudent.age_bracket}}</b>
                </p>
              </mdb-col>
            </mdb-row>
          </div>
          <div class="mt-2 table-responsive">
            <table class="table table-bordered">
              <thead class="thead-dark">
                <tr>
                  <th>Digits viewed</th>
                  <th>Lines viewed</th>
                  <th>Selected digits</th>
                  <th>Rights</th>
                  <th>Wrongs</th>
                  <th>Missed</th>
                  <th>Attention speed</th>
                  <th>Mental productivity</th>
                  <th>Mental performance</th>
                  <th>Concentration %</th>
                  <th>Test time</th>
                  <th>Date time</th>
              </tr>
              </thead>
              <tbody>
                <tr v-for="test in bourdonTests" :key="test._id">
                  <td>{{test.nn}}</td>
                  <td>{{test.cc}}</td>
                  <td>{{test.mm}}</td>
                  <td>{{test.ss}}</td>
                  <td>{{test.oo}}</td>
                  <td>{{test.pp}}</td>
                  <td>{{test.aa}}</td>
                  <td>{{test.ee}}</td>
                  <td>{{test.au}}</td>
                  <td>{{test.kk}}</td>
                  <td>{{test.t}}</td>
                  <td>{{miliToDate(test.created_at)}}</td>
                </tr>
              </tbody>
            </table>
          </div>
      </mdb-modal-body>
    </mdb-modal>

    <mdb-modal size="md" class="videoConferencing" :show="showActivationModal" removeBackdrop centered scrollable>
      <mdb-modal-body v-if="!selectedStudent.disabled">
        <h4 class="text text-center text-bold">Do you want to deactive this student?</h4>
        <div class="d-flex" style="justify-content:center">
          <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal" @click="showActivationModal = false">Close</button>
          <button type="button" class="btn btn-black btn-sm" data-dismiss="modal" @click="showActivationModal = false;deactivate()">Deactive</button>
        </div>
      </mdb-modal-body>
      <mdb-modal-body v-if="selectedStudent.disabled">
        <h4 class="text text-center text-bold">Do you want to active this student?</h4>
        <div class="d-flex" style="justify-content:center">
          <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal" @click="showActivationModal = false">Close</button>
          <button type="button" class="btn btn-success btn-sm" data-dismiss="modal" @click="showActivationModal = false;activate()">Active</button>
        </div>
      </mdb-modal-body>
    </mdb-modal>

    <mdb-modal size="xl" :show="showStatusReportModal" centered scrollable>
      <student-status-report :defaultGroup="selectGroup" @closeDialog="showStatusReportModal=false"></student-status-report>
    </mdb-modal>
  </section>
</template>

<script>
import axios from "axios";
import { mdbRow, mdbCol, mdbCard, mdbCardBody, mdbIcon,  mdbModal,
    mdbModalBody,} from "mdbvue";
import StudentStatusReport from './StudentStatusReport';

export default {
  name: "Report",
  components: {
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardBody,
    mdbIcon,
    mdbModal,
    mdbModalBody,
    StudentStatusReport
  },
  data() {
    return {
      totalGroups: [],
      totalLevels: [],
      classes: JSON.parse(localStorage.getItem("classes")),
      totalTypes: ['School', 'After School'],
      totalPrograms: ['Runner', 'Toddler'],
      students: [],
      disabledStudents: [],
      teachers: [],
      currentPage: 'report',
      searchStudent: '',
      searchTeacher: '',
      searchClass: '',
      searchGroup: '',
      selectGroup: '',
      searchType: '',
      searchProgram: '',
      searchLevel: '',
      changingGroup: '',
      changingLevel: '',
      isSelectedUser: false,
      showBourdonModal: false,
      showStatusReportModal: false,
      showActivationModal: false,
      selectedStudent: {},
      bourdonTests: [],
      currentLevel: {},
      levels: [],
      progress: {},
      studentDetails: [],
      lessons: [],
      checkedIds: [],
      fastAdminToken: localStorage.getItem("fastAdminToken"),
    };
  },

  methods: {
    viewDisabledStudents() {
      this.currentPage = 'disabled-student';
      this.students = this.disabledStudents;
    },

    searchStudentF() {

      if(this.searchStudent == '') {
        this.$toast.open({
            message: "Error: Please input student info",
            type: 'error'
        });
        return;
      }

      this.currentPage = 'search-student';

      
      const config = {
          headers: {
              Authorization: "Bearer " + this.fastAdminToken,
              'Content-Type': 'application/json'
          }
      }

      let data = {
        type: 'search',
        value: this.searchStudent
      };

      axios.post(this.$apiURI + "/account/search-students", data, config)
          .then((response) => {
              if (response.data.error) {
                  this.$toast.open({
                      message: "Error : " + response.data.message,
                      type: 'error'
                  });
              } else {
                  
                  // eslint-disable-next-line no-console
                  // console.log(response.data.data.teachers)
                  this.checkedIds = [];
                  this.students = response.data.data.students.filter(item => {
                    return !item.disabled;
                  })
              }

          }).catch((error) => {
              this.$toast.open({
                  message: "Error : " + error.response.data.message,
                  type: 'error'
              });
          })

    },

    searchDisabledStudentF() {

      if(this.searchStudent == '') {
        this.$toast.open({
            message: "Error: Please input student info",
            type: 'error'
        });
        return;
      }

      const config = {
          headers: {
              Authorization: "Bearer " + this.fastAdminToken,
              'Content-Type': 'application/json'
          }
      }

      let data = {
        type: 'search-disabled',
        value: this.searchStudent
      };

      axios.post(this.$apiURI + "/account/search-students", data, config)
          .then((response) => {
              if (response.data.error) {
                  this.$toast.open({
                      message: "Error : " + response.data.message,
                      type: 'error'
                  });
              } else {
                  
                  // eslint-disable-next-line no-console
                  // console.log(response.data.data.teachers)
                  this.checkedIds = [];
                  this.students = response.data.data.students;
              }

          }).catch((error) => {
              this.$toast.open({
                  message: "Error : " + error.response.data.message,
                  type: 'error'
              });
          })
    },

    searchTeacherF() {

      if(this.searchTeacher == '') {
        this.$toast.open({
            message: "Error: Please input teacher info",
            type: 'error'
        });
        return;
      }

      this.currentPage = 'search-teacher';


        const config = {
            headers: {
                Authorization: "Bearer " + this.fastAdminToken,
                'Content-Type': 'application/json'
            }
        }

        let data = {
          searchKey: this.searchTeacher
        };

        axios.post(this.$apiURI + "/account/search-teachers", data, config)
            .then((response) => {
                if (response.data.error) {
                    this.$toast.open({
                        message: "Error : " + response.data.message,
                        type: 'error'
                    });
                } else {
                    
                    // eslint-disable-next-line no-console
                    // console.log(response.data.data.teachers)
                    this.teachers = response.data.data.teachers
                }

            }).catch((error) => {
                this.$toast.open({
                    message: "Error : " + error.response.data.message,
                    type: 'error'
                });
            })
    },

    searchClassF() {

      if(this.searchClass == '') {
        this.$toast.open({
            message: "Error: Please input class name",
            type: 'error'
        });
        return;
      }

      this.currentPage = 'search-by-class';

      const config = {
          headers: {
              Authorization: "Bearer " + this.fastAdminToken,
              'Content-Type': 'application/json'
          }
      }

      let data = {
        type: 'class',
        value: this.searchClass
      };

      axios.post(this.$apiURI + "/account/search-students", data, config)
          .then((response) => {
              if (response.data.error) {
                  this.$toast.open({
                      message: "Error : " + response.data.message,
                      type: 'error'
                  });
              } else {
                  
                  // eslint-disable-next-line no-console
                  // console.log(response.data.data.teachers)
                  this.checkedIds = [];
                  this.students = response.data.data.students.filter(item => {
                    return !item.disabled;
                  })
              }

          }).catch((error) => {
              this.$toast.open({
                  message: "Error : " + error.response.data.message,
                  type: 'error'
              });
          })


    },

    searchGroupF() {

      if(this.searchGroup == '') {
        this.$toast.open({
            message: "Error: Please select a group",
            type: 'error'
        });
        return;
      }

      this.currentPage = 'search-by-group';

      const config = {
          headers: {
              Authorization: "Bearer " + this.fastAdminToken,
              'Content-Type': 'application/json'
          }
      }

      let data = {
        type: 'group',
        value: this.searchGroup
      };

      axios.post(this.$apiURI + "/account/search-students", data, config)
          .then((response) => {
              if (response.data.error) {
                  this.$toast.open({
                      message: "Error : " + response.data.message,
                      type: 'error'
                  });
              } else {
                  
                  // eslint-disable-next-line no-console
                  // console.log(response.data.data.teachers)
                  this.checkedIds = [];
                  this.students = response.data.data.students.filter(item => {
                    return !item.disabled;
                  })
              }

          }).catch((error) => {
              this.$toast.open({
                  message: "Error : " + error.response.data.message,
                  type: 'error'
              });
          })

    },

    goStatusReport() {

      if(this.selectGroup == '') {
        this.$toast.open({
            message: "Error: Please select a group",
            type: 'error'
        });
        return;
      }
      this.showStatusReportModal = true;

    },

    searchTypeF() {

      if(this.searchType == '') {
        this.$toast.open({
            message: "Error: Please select a type",
            type: 'error'
        });
        return;
      }

      this.currentPage = 'search-by-type';

      const config = {
          headers: {
              Authorization: "Bearer " + this.fastAdminToken,
              'Content-Type': 'application/json'
          }
      }

      let data = {
        type: 'type',
        value: this.searchType
      };

      axios.post(this.$apiURI + "/account/search-students", data, config)
          .then((response) => {
              if (response.data.error) {
                  this.$toast.open({
                      message: "Error : " + response.data.message,
                      type: 'error'
                  });
              } else {
                  
                  // eslint-disable-next-line no-console
                  // console.log(response.data.data.teachers)
                  this.checkedIds = [];
                  this.students = response.data.data.students.filter(item => {
                    return !item.disabled;
                  })
              }

          }).catch((error) => {
              this.$toast.open({
                  message: "Error : " + error.response.data.message,
                  type: 'error'
              });
          })

    },

    searchProgramF() {

      if(this.searchProgram == '') {
        this.$toast.open({
            message: "Error: Please select a program",
            type: 'error'
        });
        return;
      }

      this.currentPage = 'search-by-program';

      const config = {
          headers: {
              Authorization: "Bearer " + this.fastAdminToken,
              'Content-Type': 'application/json'
          }
      }

      let data = {
        type: 'program',
        value: this.searchProgram
      };

      axios.post(this.$apiURI + "/account/search-students", data, config)
          .then((response) => {
              if (response.data.error) {
                  this.$toast.open({
                      message: "Error : " + response.data.message,
                      type: 'error'
                  });
              } else {
                  
                  // eslint-disable-next-line no-console
                  // console.log(response.data.data.teachers)
                  this.checkedIds = [];
                  this.students = response.data.data.students.filter(item => {
                    return !item.disabled;
                  })
              }

          }).catch((error) => {
              this.$toast.open({
                  message: "Error : " + error.response.data.message,
                  type: 'error'
              });
          })

    },

    searchLevelF() {

      if(this.searchLevel == '') {
        this.$toast.open({
            message: "Error: Please select a level",
            type: 'error'
        });
        return;
      }

      this.currentPage = 'search-by-level';

      const config = {
          headers: {
              Authorization: "Bearer " + this.fastAdminToken,
              'Content-Type': 'application/json'
          }
      }

      let data = {
        type: 'level',
        value: this.searchLevel
      };

      axios.post(this.$apiURI + "/account/search-students", data, config)
          .then((response) => {
              if (response.data.error) {
                  this.$toast.open({
                      message: "Error : " + response.data.message,
                      type: 'error'
                  });
              } else {
                  
                  // eslint-disable-next-line no-console
                  // console.log(response.data.data.teachers)
                  this.checkedIds = [];
                  this.students = response.data.data.students.filter(item => {
                    return !item.disabled;
                  })
              }

          }).catch((error) => {
              this.$toast.open({
                  message: "Error : " + error.response.data.message,
                  type: 'error'
              });
          })

    },

    returnReport() {
      this.currentPage = 'report';
      this.initData();
    },

    getAllStudents() {

      this.initData();
      const config = {
          headers: {
              Authorization: "Bearer " + this.fastAdminToken,
              'Content-Type': 'application/json'
          }
      }
      axios
        .get(this.$apiURI + "/account/students", config)
        .then((response) => {
          if (response.data.error) {
            this.$toast.open({
              message: "Error : " + response.data.message,
              type: "error",
            });
          } else {
            // eslint-disable-next-line no-console
            // console.log(response.data.data.teachers)
                  this.checkedIds = [];
            this.students = response.data.data.students.filter(item => {
                    return !item.disabled;
                  });
          }
        })
        .catch((error) => {
          this.$toast.open({
            message: "Error : " + error.response.data.message,
            type: "error",
          });
        });
    },

    getAllTeachers() {

        this.initData();

        const config = {
            headers: {
                Authorization: "Bearer " + this.fastAdminToken,
                'Content-Type': 'application/json'
            }
        }


        axios.get(this.$apiURI + "/account/teachers", config)
            .then((response) => {
                if (response.data.error) {
                    this.$toast.open({
                        message: "Error : " + response.data.message,
                        type: 'error'
                    });
                } else {
                    
                    // eslint-disable-next-line no-console
                    // console.log(response.data.data.teachers)
                    this.teachers = response.data.data.teachers
                }

            }).catch((error) => {
                this.$toast.open({
                    message: "Error : " + error.response.data.message,
                    type: 'error'
                });
            })
    },

    downloadCSV() {
      if(this.currentPage == 'search-teacher') {
        this.exportToCsv('teachers.csv', this.teachers);
      } else {
        this.exportToCsv('students.csv', this.students);
      }
    },

    exportToCsv(filename, rows) {
        let csv = '';
        // let header = Object.keys(rows[9]).join(',');
        let header = ['_id', 'name','first_name','last_name','middle_name','group','level','username','age_bracket','school_grade','city','county','country','guardian_email','teacher','date_joined','role','class','name','gender','type','registration_date','starting_age','class_day','class_schedule','date_assigned'];
        let values = '';
        Object.keys(rows).forEach(key => {
          Object.values(header).forEach(value => {
            values += rows[key][value] + ', '
          });
          values += '\n';
        });

        csv += header + '\n' + values;

        var blob = new Blob([csv], { type: 'text/csv;charset=utf-8,%EF%BB%BF' });
        if (navigator.msSaveBlob) { // IE 10+
            navigator.msSaveBlob(blob, filename);
        } else {
            var link = document.createElement("a");
            if (link.download !== undefined) { // feature detection
                // Browsers that support HTML5 download attribute
                var url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", filename);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    },

    initData() {
      this.searchStudent='';
      this.searchTeacher='';
      this.searchClass='';
      this.searchGroup='';
      this.searchType='';
      this.searchProgram='';
      this.searchLevel='';
      this.checkedIds = [];
      this.getDisabledStudents();
    },

    activationStudent(student) {
      this.selectedStudent = student;
      this.showActivationModal = true;
    },

    activate() {
      const account_id = this.selectedStudent._id;
      const config = {
            headers: {
                Authorization: "Bearer " + this.fastAdminToken,
                'Content-Type': 'application/json'
            }
        }
        this.$toast.open({
            message: "Processing : Activating Account Please Wait...",
            type: 'info'
        })
        axios.post(this.$apiURI + "/account/" + account_id + "/activate", {}, config)
            .then((response) => { 
                if (response.data.error) {
                    this.$toast.open({
                        message: "Error : " + response.data.message,
                        type: 'error'
                    });
                } else {
                    this.$toast.open({
                        message: "Account Activated Successfully",
                        type: 'success'
                    })
                    this.selectedStudent.disabled = false;
                    this.students = this.students.filter(item => {
                      return item.disabled;
                    })
                }

            }).catch((error) => {
                this.$toast.open({
                    message: "Error : " + error.response.data.message,
                    type: 'error'
                });
            })
    },

    deactivate() {
      const account_id = this.selectedStudent._id;
      const config = {
            headers: {
                Authorization: "Bearer " + this.fastAdminToken,
                'Content-Type': 'application/json'
            }
        }
        this.$toast.open({
            message: "Processing : Disabling Account Please Wait...",
            type: 'info'
        })
        axios.post(this.$apiURI + "/account/" + account_id + "/deactivate", {},config)
            .then((response) => {
                if (response.data.error) {
                    this.$toast.open({
                        message: "Error : " + response.data.message,
                        type: 'error'
                    });
                } else {
                    this.$toast.open({
                        message: "Account Disabled Successfully",
                        type: 'success'
                    })
                    this.selectedStudent.disabled = true;
                    this.students = this.students.filter(item => {
                      return !item.disabled;
                    })
                }

            }).catch((error) => {
                this.$toast.open({
                    message: "Error : " + error.response.data.message,
                    type: 'error'
                });
            })
    },

    bulkDeactivate() {
        const config = {
            headers: {
                Authorization: "Bearer " + this.fastAdminToken,
                'Content-Type': 'application/json'
            }
        }
        this.$toast.open({
            message: "Processing : Disabling Account Please Wait...",
            type: 'info'
        })
        axios.post(this.$apiURI + "/account/bulk-deactivate", {ids: this.checkedIds},config)
            .then((response) => {
                if (response.data.error) {
                    this.$toast.open({
                        message: "Error : " + response.data.message,
                        type: 'error'
                    });
                } else {
                    this.$toast.open({
                        message: "Account Disabled Successfully",
                        type: 'success'
                    })
                    this.students = this.students.filter(item => {
                      return !this.checkedIds.includes(item._id);
                    })
                    this.checkedIds = [];
                }

            }).catch((error) => {
                this.$toast.open({
                    message: "Error : " + error.response.data.message,
                    type: 'error'
                });
            })
    },

    bulkChangeGroup() {
      if(this.changingGroup == '') {
        this.$toast.open({
            message: "Error: Please select a group",
            type: 'error'
        });
        return;
      }

        const config = {
            headers: {
                Authorization: "Bearer " + this.fastAdminToken,
                'Content-Type': 'application/json'
            }
        }
        this.$toast.open({
            message: "Processing : Changing Account Please Wait...",
            type: 'info'
        })
        axios.post(this.$apiURI + "/account/bulk-change-group", {ids: this.checkedIds, group: this.changingGroup},config)
            .then((response) => {
                if (response.data.error) {
                    this.$toast.open({
                        message: "Error : " + response.data.message,
                        type: 'error'
                    });
                } else {
                    this.$toast.open({
                        message: "Account Changed Successfully",
                        type: 'success'
                    })
                    for (var index in this.students) {
                      if (this.checkedIds.includes(this.students[index]._id)) {
                        this.students[index].group = this.changingGroup;
                      }
                    }
                }

            }).catch((error) => {
                this.$toast.open({
                    message: "Error : " + error.response.data.message,
                    type: 'error'
                });
            })
    },

    bulkChangeLevel() {
      if(this.changingLevel == '') {
        this.$toast.open({
            message: "Error: Please select a level",
            type: 'error'
        });
        return;
      }
        const config = {
            headers: {
                Authorization: "Bearer " + this.fastAdminToken,
                'Content-Type': 'application/json'
            }
        }
        this.$toast.open({
            message: "Processing : Changing Account Please Wait...",
            type: 'info'
        })
        axios.post(this.$apiURI + "/account/bulk-change-level", {ids: this.checkedIds, level: this.changingLevel},config)
            .then((response) => {
                if (response.data.error) {
                    this.$toast.open({
                        message: "Error : " + response.data.message,
                        type: 'error'
                    });
                } else {
                    this.$toast.open({
                        message: "Account Changed Successfully",
                        type: 'success'
                    })

                    const level = this.changingLevel.split(" ")[1];
                    const target = this.changingLevel.split(" ")[0];
                    
                    for (var index in this.students) {
                      if (this.checkedIds.includes(this.students[index]._id)) {
                        this.students[index].level = level;
                        this.students[index].age_bracket = target;
                        this.students[index].lesson = 1;
                        this.students[index].lesson_day = 1;
                        this.students[index].lesson_type = "s";
                      }
                    }
                }

            }).catch((error) => {
                this.$toast.open({
                    message: "Error : " + error.response.data.message,
                    type: 'error'
                });
            })
    },

    getStudentProgress(student) {
      this.progress = {};
      this.currentLevel = {};
      this.studentDetails = [];

      this.isSelectedUser = true;
      this.selectedStudent = student;
      this.$toast.open({
            message: "Processing : Loading Student Data Please Wait...",
            type: "info",
          });
      const config = {
        headers: {
          Authorization: "Bearer " + this.fastAdminToken,
          "Content-Type": "application/json",
        },
      };
      axios
        .get(this.$apiURI + "/progress/current/" + student._id, config)
        .then((response) => {
          if (response.data.error) {
            this.$toast.open({
              message: "Error : " + response.data.message,
              type: "error",
            });
          } else {
            // eslint-disable-next-line no-console
            // console.log(response.data.data.teachers)
            this.progress = response.data.data;
            console.log(this.progress)

            this.levels = [];
            for (var item of this.progress.levels) {
              this.levels.push(item);
              if (item._id == this.progress.level_data._id) {
                this.currentLevel = item;
                break;
              }
            }
            this.loadLesssons();
          }
        })
        // .catch((error) => {

        //   this.$toast.open({
        //     message: "Error : " + error.response.data.message,
        //     type: "error",
        //   });
        // });
    },

    loadLesssons() {
      this.$toast.open({
            message: "Processing : Loading Lesson Data, Please Wait...",
            type: "info",
          });
      const config = {
        headers: {
          Authorization: "Bearer " + this.fastAdminToken,
          "Content-Type": "application/json",
        },
      };
      axios
        .get(this.$apiURI + `/levels/${this.currentLevel._id}/lessons`, config)
        .then((response) => {
          if (response.data.error) {
            this.$toast.open({
              message: "Error : " + response.data.message,
              type: "error",
            });
          } else {
            this.lessons = response.data.data.lessons;
            this.loadScore();
          }
        })
        // .catch((error) => {
        //   this.$toast.open({
        //     message: "Error : " + error.response.data.message,
        //     type: "error",
        //   });
        // });
    },

    loadScore() {
      this.$toast.open({
            message: "Processing : Loading Score Data, Please Wait...",
            type: "info",
          });
      const config = {
        headers: {
          Authorization: "Bearer " + this.fastAdminToken,
          "Content-Type": "application/json",
        },
      };
      axios
        .get(this.$apiURI + `/progress/student/${this.currentLevel._id}/${this.selectedStudent._id}`, config)
        .then((response) => {
          if (response.data.error) {
            this.$toast.open({
              message: "Error : " + response.data.message,
              type: "error",
            });
          } else {
            let progressData = response.data.data.progresses;
            let parseProgressData = this.groupBy(progressData, 'group');
            this.studentDetails = [];
            for (var index in this.lessons) {
              let lessonDetails = {};
              lessonDetails['total'] = 0;
              lessonDetails['passed'] = 0;
              lessonDetails['index'] = index;
              lessonDetails['status'] = 'current';
              lessonDetails['score'] = 100;
              lessonDetails['s_score'] = 100;
              lessonDetails['a_score'] = 100;
              lessonDetails['f_score'] = 100;
              lessonDetails['show'] = false;
              for (var subIndex in this.lessons[index]) {
                lessonDetails['total'] += this.lessons[index][subIndex]['homework'].length;
              }              

              if (parseProgressData[index]) {
                let totalScore = 0;
                let s_totalScore = 0;
                let s_totalCount = 0;
                let a_totalScore = 0;
                let a_totalCount = 0;
                let f_totalScore = 0;
                let f_totalCount = 0;
                lessonDetails['passed'] = parseProgressData[index].length;
                for (var progressIndex in parseProgressData[index]) {
                  let score = parseProgressData[index][progressIndex].points;
                  if (score == -1) {
                    score = 100;
                  }
                  totalScore += score;
                  if (parseProgressData[index][progressIndex].type == 's') {
                    s_totalScore += score;
                    s_totalCount++;
                  }
                  if (parseProgressData[index][progressIndex].type == 'f') {
                    f_totalScore += score;
                    f_totalCount++;
                  }
                  if (parseProgressData[index][progressIndex].type == 'a') {
                    a_totalScore += score;
                    a_totalCount++;
                  }
                }
                lessonDetails['score'] = Math.round(totalScore / lessonDetails['passed']);
                lessonDetails['s_score'] = Math.round(s_totalScore / s_totalCount);
                lessonDetails['a_score'] = Math.round(a_totalScore / a_totalCount);
                lessonDetails['f_score'] = Math.round(f_totalScore / f_totalCount);
              }

              if (lessonDetails['total'] <= lessonDetails['passed']) {
                lessonDetails['passed'] = lessonDetails['total'];
                lessonDetails['status'] = 'past';
              } else if (lessonDetails['passed'] == 0) {
                lessonDetails['status'] = 'pending';
              }

              if (this.selectedStudent.level > this.currentLevel.step) {
                lessonDetails['passed'] = lessonDetails['total'];
                lessonDetails['status'] = 'past';
              }

              this.studentDetails.push(lessonDetails);
            }
          }
        })
        .catch((error) => {
          this.$toast.open({
            message: "Error : " + error.response.data.message,
            type: "error",
          });
        });
    },

    groupBy(xs, key) {
      return xs.reduce(function(rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    },

    getStudentBourdon(student) {
      this.showBourdonModal = true;
      this.selectedStudent = student;
      this.$toast.open({
            message: "Processing : Loading Student Data Please Wait...",
            type: "info",
          });

      const config = {
        headers: {
          Authorization: "Bearer " + this.fastAdminToken,
          "Content-Type": "application/json",
        },
      };
      axios
        .get(this.$apiURI + "/account/bourdon/all?user_id=" + student._id, config)
        .then((response) => {
          if (response.data.error) {
            this.$toast.open({
              message: "Error : " + response.data.message,
              type: "error",
            });
          } else {
            this.bourdonTests = response.data.data.data;
          }
        })
        .catch((error) => {
          this.$toast.open({
            message: "Error : " + error.response.data.message,
            type: "error",
          });
        });
    },

    miliToDate(milis) {
      var date = new Date(milis);
      return date.toLocaleString().replaceAll(',', '');
    },

    getDisabledStudents() {
      this.disabledStudents = [];
      this.$toast.open({
        message: "Processing : Loading Students Data Please Wait...",
        type: "info",
      });

      const config = {
        headers: {
          Authorization: "Bearer " + this.fastAdminToken,
          "Content-Type": "application/json",
        },
      };
      axios
        .get(this.$apiURI + "/account/disabled-students", config)
        .then((response) => {
          if (response.data.error) {
            this.$toast.open({
              message: "Error : " + response.data.message,
              type: "error",
            });
          } else {
            if (response.data.data.students.length > 0) {
              this.disabledStudents = response.data.data.students;
            }
          }
        })
        .catch((error) => {
          this.$toast.open({
            message: "Error : " + error.response.data.message,
            type: "error",
          });
        });
    }
  },

  mounted() {
    this.$toast.open({
      message: "Processing : Loading Dashboard Data Please Wait...",
      type: "info",
    });

    const config = {
      headers: {
        Authorization: "Bearer " + this.fastAdminToken,
        "Content-Type": "application/json",
      },
    };


    axios
      .get(this.$apiURI + "/levels", config)
      .then((response) => {
        if (response.data.error) {
          this.$toast.open({
            message: "Error : " + response.data.message,
            type: "error",
          });
        } else {
          // eslint-disable-next-line no-console
          // console.log(response.data.data.teachers)
          let levels = response.data.data.levels;
          this.totalLevels = levels;
        }
      })
      .catch((error) => {
        this.$toast.open({
          message: "Error : " + error.response.data.message,
          type: "error",
        });
      });

      
    axios
      .get(this.$apiURI + "/groups", config)
      .then((response) => {
        if (response.data.error) {
          this.$toast.open({
            message: "Error : " + response.data.message,
            type: "error",
          });
        } else {
          let groups = response.data.data.groups;
          this.totalGroups = groups;
        }
        this.getDisabledStudents();
      })
      .catch((error) => {
        this.$toast.open({
          message: "Error : " + error.response.data.message,
          type: "error",
        });
      });


  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.cascading-admin-card {
  margin: 20px 0;
  background: #1c2331 !important;
}

.btn:hover {
  color: #fff;
}

.cascading-admin-card .admin-up {
  margin-left: 4%;
  margin-right: 4%;
  margin-top: -20px;
  background: #1c2331 !important;
}

.cascading-admin-card .admin-up .fas,
.cascading-admin-card .admin-up .far {
  box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.2), 0 2px 13px 0 rgba(0, 0, 0, 0.19);
  padding: 1rem;
  font-size: 1rem;
  color: #fff;
  text-align: left;
  margin-right: 1rem;
  border-radius: 3px;
  background: #1c2331 !important;
}

.cascading-admin-card .admin-up .data {
  float: right;
  margin-top: 2rem;
  text-align: right;
}

.admin-up .data p {
  color: #999999;
  font-size: 12px;
}

.classic-admin-card .card-body {
  color: #fff;
  margin-bottom: 0;
  padding: 0.9rem;
}

.classic-admin-card .card-body p {
  font-size: 13px;
  opacity: 0.7;
  margin-bottom: 0;
}

.classic-admin-card .card-body h4 {
  margin-top: 10px;
}
</style>
